import mobile_util from './mobile_util'

function isEmbed() {
  return window.config && window.config.hosted_in === 'embed';
}

function cookie(name, value, options) {
  /* view http://plugins.jquery.com/files/jquery.cookie.js.txt
   here we directly append this to window object instead of jQuery */
  if (typeof value != 'undefined') {
    options = options || {};
    if (value === null) {
      value = '';
      options.expires = -1;
    }
    var expires = '';
    if (
      options.expires &&
      (typeof options.expires == 'number' || options.expires.toUTCString)
    ) {
      var date;
      if (typeof options.expires == 'number') {
        date = new Date();
        date.setTime(date.getTime() + options.expires * 24 * 60 * 60 * 1000);
      } else {
        date = options.expires;
      }
      expires = '; expires=' + date.toUTCString();
    }
    var path = options.path ? '; path=' + options.path : '';
    var domain = options.domain ? '; domain=' + options.domain : '';
    var secure = options.secure ? '; secure' : '';
    document.cookie = [
      name,
      '=',
      encodeURIComponent(value),
      expires,
      path,
      domain,
      secure,
    ].join('');
  } else {
    var cookieValue = null;
    if (document.cookie && document.cookie !== '') {
      var cookies = document.cookie.split(';');
      for (var i = 0; i < cookies.length; i++) {
        var the_cookie = jQuery.trim(cookies[i]);
        if (the_cookie.substring(0, name.length + 1) == name + '=') {
          cookieValue = decodeURIComponent(
            the_cookie.substring(name.length + 1)
          );
          break;
        }
      }
    }
    return cookieValue;
  }
}

function fireOrientationEvent() {
  var orientation, deviceType;
  if (screen.width >= 768) {
    deviceType = 'Tablet';
  } else {
    deviceType = 'Phone';
  }

  if (window.orientation == 90 || window.orientation == -90) {
    //Landscape
    orientation = 'Landscape';
  } else {
    orientation = 'Portrait';
  }
  window._gaq.push([
    '_trackEvent',
    'MobileApp',
    'orientation' + orientation + deviceType,
  ]);
}

// top tier EU locales. If we see any of these, we must show the banner
var euTier1 = ['en-GB', 'de', 'fr', 'it', 'nl', 'es'];
var inLocale = function (locale) {
  var result =
    this.findIndex(function (current) {
      return current.toString().toLowerCase() === this.toString().toLowerCase();
    }, locale) != -1;
  return result;
};

var isEuLocale = function (locales) {
  // top tier EU locales. If we see any of these, we must show the banner
  locales = locales.map(function (locale) {
    return locale.toLowerCase();
  });
  var euTier1 = [
    'en-gb',
    'pt-pt',
    'de',
    'de-de',
    'fr',
    'fr-fr',
    'it',
    'it-it',
    'nl',
    'nl-nl',
    'es',
    'es-es',
  ];
  for (var i = 0; i < locales.length; i++) {
    var locale = locales[i];
    if (euTier1.indexOf(locale) != -1) {
      return true;
    }
  }
  if (locales.indexOf('pt') != -1 && locales.indexOf('pt-br') == -1) {
    return true;
  } else if (locales.indexOf('en') != -1 && locales.indexOf('en-us') == -1) {
    return true;
  } else {
    return false;
  }
};

// Determine if the Term of Service banner should be shown and display it
function initTOSBanner() {
  var $tosBanner = $('.j-tos-update-banner');
  var $showText = $tosBanner.find('.j-mobile-text');
  var $contentContainer = $('#content_container');
  var displayCount = parseInt(
    mobile_util.getCookie('tos_update_banner_shows'),
    4
  );
  displayCount = isNaN(displayCount) ? 0 : displayCount;
  if ($tosBanner.length && displayCount < 1) {
    $tosBanner.show();
    $showText.show();
    $contentContainer.css(
      'margin-top',
      parseInt($contentContainer.css('margin-top'), 10) + $tosBanner.height()
    );
    mobile_util.setCookie('tos_update_banner_shows', displayCount + 1, 365);

    $tosBanner.find('.j-tos-close').on('click', function (e) {
      $contentContainer.css(
        'margin-top',
        parseInt($contentContainer.css('margin-top'), 10) - $tosBanner.height()
      );
      $tosBanner.hide();
      $showText.hide();
    });
  }
}

$(window).load(function () {
  if (isEmbed()) {
    return;
  }

  _gaq.push(['_setAccount', 'UA-2330466-1']);
  _gaq.push(['_setDomainName', '.slideshare.net']);
  _gaq.push(['_addIgnoredRef', 'slideshare.net']);
  _gaq.push(['_trackPageview']);

  var ga = document.createElement('script');
  ga.type = 'text/javascript';
  ga.async = true;
  ga.src =
    ('https:' == document.location.protocol ? 'https://ssl' : 'http://www') +
    '.google-analytics.com/ga.js';
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(ga, s);
  fireOrientationEvent();
  var viewOrientation =
    window.orientation === 0 || window.orientation === undefined
      ? '_portrait'
      : '_landscape';

  // TOS Update Banner
  var langs;
  if (navigator.languages) {
    langs = navigator.languages;
  } else {
    if (navigator.language) {
      langs = [navigator.language];
    } else {
      langs = [];
    }
  }
  if (isEuLocale(langs)) {
    initTOSBanner();
  }
});

export function updateSlideNumber(number) {
  var totalSlides = parseInt($('#total_slides_number').text(), 10);
  $('.current_slide_number').text(Math.min(number, totalSlides));
}

function getUrlVars(url) {
  url = url ? url : window.location.href;
  var vars = [],
    hash;
  var hashes = url.slice(url.indexOf('?') + 1).split('&');
  for (var i = 0; i < hashes.length; i++) {
    hash = hashes[i].split('=');
    vars.push(hash[0]);
    vars[hash[0]] = hash[1];
  }
  return vars;
}

function getUrlVar(name, url) {
  return this.getUrlVars(url)[name];
}

function isInternalRedirect(url) {
  url = decodeURIComponent(url);
  var dummy_anchor = document.createElement('a');
  dummy_anchor.href = url;
  var is_valid_protocol = /http(s)?:$/.test(dummy_anchor.protocol);
  var is_valid_hostname = new RegExp('^' + location.hostname + '$').test(
    dummy_anchor.hostname
  );
  return is_valid_protocol && is_valid_hostname;
}

export function isIos() {
  var ios = navigator.userAgent.match(/(iPhone|iPad|iPod)/i);
  return ios;
}

function isAndroid() {
  return /Android/.test(navigator.userAgent);
}

$(window).bind('orientationchange', function () {
  fireOrientationEvent();
  var deviceHeight = $(window).height();
  var deviceWidth = $(window).width();
  var ios = isIos();
});

$(document).ready(function () {
  var deviceHeight = $(window).height();

  if (!isIos() && deviceHeight && deviceHeight < 650) {
    $('.slideShow').css('height', deviceHeight * 0.6);
  }

  // Collapse search bar on scroll

  document.addEventListener('touchmove', function () {
    if ($('#mobile-search-bar').hasClass('search-bar-open')) {
      toggleSearchBar();
    }
  });

  // Profile slideshow tab toggle
  $('.j-slide-tab').click(function () {
    $('.j-slide-tab-container').hide();
    $('.j-slide-tab').removeClass('selectedTab');
    $('.pagination').hide();
    $(this).addClass('selectedTab');
    $('#' + $(this).attr('id').replace('_button', ''))
      .addClass('selectedTab')
      .show();
  });

  $('.j-toggle-mobile-search').bind('tap, click', function (e) {
    e.stopPropagation();
    toggleSearchBar();
  });

  $('#search_form').submit(function () {
    window._gaq.push(['_trackEvent', 'MobileApp', 'searchSubmit']);
    window.location = '/search?q=' + $('#q').val();
    return false;
  });

  $('#sharebyemail').click(function (e) {
    window._gaq.push(['_trackEvent', 'MobileApp', 'shareByEmail']);
  });

  $('#j-mobileShare a').on('click', function (e) {
    window._gaq.push(['_trackEvent', 'MobileApp', 'Clicked_Share']);
  });

  $('#desktop-version').click(function (e) {
    window._gaq.push(['_trackEvent', 'MobileApp', 'desktopVersionClicked']);
  });

  $('#help').click(function (e) {
    window._gaq.push(['_trackEvent', 'MobileApp', 'helpButtonClicked']);
  });

  $('a[href="/login"]').attr(
    'href',
    '/login?from_source=' + encodeURIComponent(window.location.pathname)
  );

  (function () {
    var useragent = navigator.userAgent.match(/\([^\)]+\)/)[0];
    var frmPath = window.location.pathname;
    $('#mobileFeedback').attr(
      'href',
      'https://slideshare.wufoo.com/forms/m7x2p7/def/field113=' +
        useragent +
        '&field115=' +
        frmPath
    );
  })();

  // Toggle search bar off when they lose focus
  $(document).bind('click', function () {
    // Check if search bar is open and if it is, toggle it closed
    if (
      $('#mobile-search-bar').hasClass('search-bar-open') &&
      $('.search-field:focus').length === 0
    ) {
      toggleSearchBar();
    }
  });
});


function isSearchBarOpened() {
  return $('#mobile-search-bar').hasClass('open');
};

function toggleSearchBar() {
  var $body = $('body');
  if (isSearchBarOpened()) {
    $('#mobile-search-bar').removeClass('open').find('.search-field').blur();
    $body.removeClass('search-bar-opened');
  } else {
    $('#mobile-search-bar').addClass('open').find('.search-field').focus();
    $body.addClass('search-bar-opened');
  }
};

$(document).ready(function () {
  /* All non-GET requests will add the authenticity token
     if not already present in the data packet */
  window._xhrQ = window._xhrQ || [];
  $(document).bind('ajaxSend', function (elm, xhr, s) {
    if (!window._auth_token_name || !window._auth_token) {
      // no csrf protection present.
      // get authenticity token
      if (!window._xhrCSRF) {
        // get the csrf token
        window._xhrCSRF = true;
        $.ajax({
          url: '/account/get_form_authenticity_token',
          dataType: 'json',
          type: 'GET',
          success: function (data) {
            window._auth_token = data.auth_token;
            window._auth_token_name = 'authenticity_token';
            var i,
              xhrQ = window._xhrQ;
            // I would like to use q.unshift, but it doesnt work on IE<=8
            for (i in xhrQ) {
              if (xhrQ.hasOwnProperty(i)) {
                $.ajax(xhrQ[i]);
              }
            }
            window._xhrQ = [];
          },
        });
      }
      // if post request, then queue
      if (s.type != 'GET') {
        window._xhrQ.push(s);
        xhr.abort();
        return false;
      }
    }
    if (s.type == 'GET') {
      return;
    }
    if (s.dataType === 'json') {
      return;
    }
    if (
      s.data &&
      s.data.match(new RegExp('\\b' + window._auth_token_name + '='))
    ) {
      return;
    }
    if (s.data) {
      s.data = s.data + '&';
    } else {
      s.data = '';
      /* if there was no data, $ didn't set the content-type */
      xhr.setRequestHeader('Content-Type', s.contentType);
    }
    s.data =
      s.data +
      encodeURIComponent(window._auth_token_name) +
      '=' +
      encodeURIComponent(window._auth_token);
  });

  //mobile profile
  if ($('.userProfile').length) {
    var page = 1;
    var $moreBtn = $('#more_button');

    var more_content = function () {
      $.get(
        location.href + '/more',
        { more: 1, page_number: page + 1 },
        function (data) {
          page++;
          $('#slideshow_list_' + (page - 1)).after(data);
          if (page * window.itemsPerPage >= window.totalSlideshows) {
            $moreBtn.hide();
          }
        }
      );
    };

    $moreBtn.click(function () {
      if (page * window.itemsPerPage < window.totalSlideshows) {
        more_content();
      }
    });
  }

  /* Mobile search bar
  ---------------------- */

  $('#j-open-mobile-search').on('click', function (e) {
    e.stopPropagation();
    e.preventDefault();
    toggleSearchBar();
  });

  $('body').on('click', '#main-content-overlay', function (e) {
    e.stopPropagation();
    e.preventDefault();
    if (isSearchBarOpened()) {
      toggleSearchBar();
    }
  });

  var toggleDropdown = function (elem) {
    var dropdownMenu = elem.find('.dropdown-menu');
    var isActive = dropdownMenu.hasClass('open');
    if (isActive) {
      dropdownMenu.hide();
      dropdownMenu.removeClass('open');
    } else {
      dropdownMenu.show();
      dropdownMenu.addClass('open');
    }
  };

  $('.dropdown').on('click', function (e) {
    e.stopPropagation();
    toggleDropdown($(this));
  });

  $('#upload-link').hide();
});
